import { Text } from '@lichtblick/photon/atoms/text/text';
import type { TariffsQuery } from '@/types/generated';
import styles from './legal-information.module.css';

export const LegalInformation = ({ product }: { product: TariffsQuery['tariffs'][number] }) => {
  return (
    <>
      {product.description && (
        <div className={styles.description}>
          <Text size="s">
            {/** biome-ignore lint/security/noDangerouslySetInnerHtml: Content provided by PC */}
            <span dangerouslySetInnerHTML={{ __html: product.description }} />
          </Text>
        </div>
      )}

      {product.legalParagraph && (
        <div className={styles.legal}>
          {product.legalParagraph?.title && (
            <Text bold className={styles.title} size="l">
              <span
                // biome-ignore lint/security/noDangerouslySetInnerHtml: Content provided by PC
                dangerouslySetInnerHTML={{
                  __html: product.legalParagraph.title,
                }}
              />
            </Text>
          )}
          {product.legalParagraph?.body && (
            <Text size="xs">
              <span
                // biome-ignore lint/security/noDangerouslySetInnerHtml: Content provided by PC
                dangerouslySetInnerHTML={{
                  __html: product.legalParagraph.body,
                }}
              />
            </Text>
          )}
        </div>
      )}
    </>
  );
};
